import * as React from "react";

const RestApiIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M20.035 18.134H18.64a.75.75 0 1 1 0-1.5h1.395c.946 0 1.715-.769 1.715-1.714 0-.946-.77-1.715-1.715-1.715h-.5a1.74 1.74 0 0 1-1.738-1.74v-.224c0-3.185-2.511-5.86-5.598-5.964a5.76 5.76 0 0 0-4.228 1.626 5.75 5.75 0 0 0-1.767 4.167v.396a1.74 1.74 0 0 1-1.74 1.74h-.499c-.945 0-1.715.768-1.715 1.714 0 .945.77 1.714 1.715 1.714H5.36a.75.75 0 1 1 0 1.5H3.965A3.22 3.22 0 0 1 .75 14.92a3.22 3.22 0 0 1 3.215-3.215h.5a.24.24 0 0 0 .239-.24v-.395c0-1.995.79-3.858 2.224-5.246a7.25 7.25 0 0 1 5.321-2.047c3.886.13 7.048 3.478 7.048 7.464v.225c0 .132.107.239.239.239h.5a3.22 3.22 0 0 1 3.214 3.214 3.22 3.22 0 0 1-3.215 3.215"
    ></path>
    <path
      fill="#000"
      d="M14.653 20.193a.75.75 0 0 1-.53-1.28l1.529-1.529-1.529-1.528a.75.75 0 0 1-.01-1.07.75.75 0 0 1 1.07.01l2.06 2.058a.75.75 0 0 1 0 1.06l-2.06 2.06a.75.75 0 0 1-.53.22m-5.306 0a.75.75 0 0 1-.53-.22l-2.059-2.059a.75.75 0 0 1 0-1.06l2.059-2.059a.75.75 0 1 1 1.06 1.06l-1.528 1.53 1.528 1.528a.75.75 0 0 1-.53 1.28m1.918.033a.75.75 0 0 1-.708-.999l1.471-4.183a.75.75 0 1 1 1.416.497l-1.472 4.184a.75.75 0 0 1-.707.501"
    ></path>
  </svg>
);

export default RestApiIcon;
